/**
 * Kamera/galeri (PWA). Telefonlarda <input type="file" capture="environment"> arka kamerayı açar;
 * galeri seçimi aynı alanla yapılır (iPhone HEIC dahil).
 *
 * Kesinti güvenliği: taslak kimliği kamera açılmadan oluşturulup IndexedDB'ye yazılır. Düşük bellekli
 * Android cihazlarda tarayıcı kamera dönüşünde sayfayı yeniden yükleyebilir; bu durumda hangi taslağın
 * açık olduğu bu işaretten okunur ve kullanıcı aynı taslağa döner (T16).
 */

const PENDING_KEY = 'aksanenerji.camera.pendingDraft';

export function markPendingCapture(draftId: string): void {
  try { sessionStorage.setItem(PENDING_KEY, draftId); } catch { /* özel mod: taslak yine de IndexedDB'de */ }
}

export function pendingCaptureDraftId(): string | null {
  try { return sessionStorage.getItem(PENDING_KEY); } catch { return null; }
}

export function clearPendingCapture(): void {
  try { sessionStorage.removeItem(PENDING_KEY); } catch { /* yok say */ }
}
